
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface QuoteLineItem {
  description: string;
  quantity: number;
  unit_price: number;
  line_total: number;
}

interface LineItemsSectionProps {
  lineItems: QuoteLineItem[];
  onUpdateLineItem: (index: number, field: keyof QuoteLineItem, value: string | number) => void;
  onRemoveLineItem: (index: number) => void;
  onAddLineItem: () => void;
}

const LineItemsSection = ({ 
  lineItems, 
  onUpdateLineItem, 
  onRemoveLineItem, 
  onAddLineItem 
}: LineItemsSectionProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Line Items</h3>
      
      <div className="grid grid-cols-5 gap-2 text-sm font-medium text-muted-foreground">
        <div>Description</div>
        <div>Quantity</div>
        <div>Unit Price</div>
        <div>Line Total</div>
        <div>Action</div>
      </div>
      
      {lineItems.map((item, index) => (
        <div key={index} className="grid grid-cols-5 gap-2 items-center">
          <div>
            <Input
              value={item.description}
              onChange={(e) => onUpdateLineItem(index, 'description', e.target.value)}
              placeholder="Description"
            />
          </div>
          <div>
            <Input
              type="number"
              value={item.quantity}
              onChange={(e) => onUpdateLineItem(index, 'quantity', parseFloat(e.target.value) || 0)}
              placeholder="Qty"
              min="0"
              step="0.01"
            />
          </div>
          <div>
            <Input
              type="number"
              value={item.unit_price}
              onChange={(e) => {
                const value = e.target.value;
                // Allow empty string during typing, otherwise parse the number
                const numericValue = value === '' ? 0 : parseFloat(value);
                onUpdateLineItem(index, 'unit_price', isNaN(numericValue) ? 0 : numericValue);
              }}
              placeholder="Unit Price (use negative for deductions)"
              step="0.01"
            />
          </div>
          <div>
            <Input
              type="number"
              value={item.line_total}
              readOnly
              className="bg-muted"
            />
          </div>
          <div>
            <Button
              type="button"
              variant="destructive"
              size="sm"
              onClick={() => onRemoveLineItem(index)}
            >
              Remove
            </Button>
          </div>
        </div>
      ))}
      
      <Button
        type="button"
        variant="outline"
        onClick={onAddLineItem}
        className="w-full"
      >
        Add Line Item
      </Button>
    </div>
  );
};

export default LineItemsSection;
